/**
 * Inserts an element at a specific index in the array.
 *
 * @param array
 * @param index
 * @param item
 */
function insertAt(array, index, item) {
    array.splice(index, 0, item);
}
/**
 * Removes an element from the array.
 *
 * @param array
 * @param item
 */
function remove(array, item) {
    const index = array.indexOf(item);
    if (index !== -1) {
        removeAt(array, index);
    }
}
/**
 * Removes an element at the index from the array.
 *
 * @param array
 * @param item
 */
function removeAt(array, index) {
    array.splice(index, 1);
}
/**
 * Swaps two elements in the array on index `i` and `j`.
 *
 * @param array
 * @param i
 * @param j
 */
function swap(array, i, j) {
    if (i < 0 || j < 0 || i >= array.length || j >= array.length) {
        throw new Error('Index out of bounds');
    }
    [array[i], array[j]] = [array[j], array[i]];
}

const i=Symbol.for("preact-signals");function t(){if(r>1){r--;return}let i,t=!1;while(void 0!==s){let o=s;s=void 0;f++;while(void 0!==o){const n=o.o;o.o=void 0;o.f&=-3;if(!(8&o.f)&&v(o))try{o.c();}catch(o){if(!t){i=o;t=!0;}}o=n;}}f=0;r--;if(t)throw i}function o(i){if(r>0)return i();r++;try{return i()}finally{t();}}let n,s;function h(i){const t=n;n=void 0;try{return i()}finally{n=t;}}let r=0,f=0,e=0;function c(i){if(void 0===n)return;let t=i.n;if(void 0===t||t.t!==n){t={i:0,S:i,p:n.s,n:void 0,t:n,e:void 0,x:void 0,r:t};if(void 0!==n.s)n.s.n=t;n.s=t;i.n=t;if(32&n.f)i.S(t);return t}else if(-1===t.i){t.i=0;if(void 0!==t.n){t.n.p=t.p;if(void 0!==t.p)t.p.n=t.n;t.p=n.s;t.n=void 0;n.s.n=t;n.s=t;}return t}}function u(i){this.v=i;this.i=0;this.n=void 0;this.t=void 0;}u.prototype.brand=i;u.prototype.h=function(){return !0};u.prototype.S=function(i){if(this.t!==i&&void 0===i.e){i.x=this.t;if(void 0!==this.t)this.t.e=i;this.t=i;}};u.prototype.U=function(i){if(void 0!==this.t){const t=i.e,o=i.x;if(void 0!==t){t.x=o;i.e=void 0;}if(void 0!==o){o.e=t;i.x=void 0;}if(i===this.t)this.t=o;}};u.prototype.subscribe=function(i){return E(()=>{const t=this.value,o=n;n=void 0;try{i(t);}finally{n=o;}})};u.prototype.valueOf=function(){return this.value};u.prototype.toString=function(){return this.value+""};u.prototype.toJSON=function(){return this.value};u.prototype.peek=function(){const i=n;n=void 0;try{return this.value}finally{n=i;}};Object.defineProperty(u.prototype,"value",{get(){const i=c(this);if(void 0!==i)i.i=this.i;return this.v},set(i){if(i!==this.v){if(f>100)throw new Error("Cycle detected");this.v=i;this.i++;e++;r++;try{for(let i=this.t;void 0!==i;i=i.x)i.t.N();}finally{t();}}}});function d(i){return new u(i)}function v(i){for(let t=i.s;void 0!==t;t=t.n)if(t.S.i!==t.i||!t.S.h()||t.S.i!==t.i)return !0;return !1}function l(i){for(let t=i.s;void 0!==t;t=t.n){const o=t.S.n;if(void 0!==o)t.r=o;t.S.n=t;t.i=-1;if(void 0===t.n){i.s=t;break}}}function y(i){let t,o=i.s;while(void 0!==o){const i=o.p;if(-1===o.i){o.S.U(o);if(void 0!==i)i.n=o.n;if(void 0!==o.n)o.n.p=i;}else t=o;o.S.n=o.r;if(void 0!==o.r)o.r=void 0;o=i;}i.s=t;}function a(i){u.call(this,void 0);this.x=i;this.s=void 0;this.g=e-1;this.f=4;}(a.prototype=new u).h=function(){this.f&=-3;if(1&this.f)return !1;if(32==(36&this.f))return !0;this.f&=-5;if(this.g===e)return !0;this.g=e;this.f|=1;if(this.i>0&&!v(this)){this.f&=-2;return !0}const i=n;try{l(this);n=this;const i=this.x();if(16&this.f||this.v!==i||0===this.i){this.v=i;this.f&=-17;this.i++;}}catch(i){this.v=i;this.f|=16;this.i++;}n=i;y(this);this.f&=-2;return !0};a.prototype.S=function(i){if(void 0===this.t){this.f|=36;for(let i=this.s;void 0!==i;i=i.n)i.S.S(i);}u.prototype.S.call(this,i);};a.prototype.U=function(i){if(void 0!==this.t){u.prototype.U.call(this,i);if(void 0===this.t){this.f&=-33;for(let i=this.s;void 0!==i;i=i.n)i.S.U(i);}}};a.prototype.N=function(){if(!(2&this.f)){this.f|=6;for(let i=this.t;void 0!==i;i=i.x)i.t.N();}};Object.defineProperty(a.prototype,"value",{get(){if(1&this.f)throw new Error("Cycle detected");const i=c(this);this.h();if(void 0!==i)i.i=this.i;if(16&this.f)throw this.v;return this.v}});function w(i){return new a(i)}function _(i){const o=i.u;i.u=void 0;if("function"==typeof o){r++;const s=n;n=void 0;try{o();}catch(t){i.f&=-2;i.f|=8;g(i);throw t}finally{n=s;t();}}}function g(i){for(let t=i.s;void 0!==t;t=t.n)t.S.U(t);i.x=void 0;i.s=void 0;_(i);}function p(i){if(n!==this)throw new Error("Out-of-order effect");y(this);n=i;this.f&=-2;if(8&this.f)g(this);t();}function b(i){this.x=i;this.u=void 0;this.s=void 0;this.o=void 0;this.f=32;}b.prototype.c=function(){const i=this.S();try{if(8&this.f)return;if(void 0===this.x)return;const t=this.x();if("function"==typeof t)this.u=t;}finally{i();}};b.prototype.S=function(){if(1&this.f)throw new Error("Cycle detected");this.f|=1;this.f&=-9;_(this);l(this);r++;const i=n;n=this;return p.bind(this,i)};b.prototype.N=function(){if(!(2&this.f)){this.f|=2;this.o=s;s=this;}};b.prototype.d=function(){this.f|=8;if(!(1&this.f))g(this);};function E(i){const t=new b(i);try{t.c();}catch(i){t.d();throw i}return t.d.bind(t)}

const signalSymbol = Symbol('signal');
function signal(value) {
    const innerSignal = d(value);
    function fn(newValue) {
        if (arguments.length === 1) {
            innerSignal.value = newValue;
            return;
        }
        return innerSignal.value;
    }
    fn[signalSymbol] = true;
    fn.peek = () => innerSignal.peek();
    fn.subscribe = (fn) => innerSignal.subscribe(fn);
    return fn;
}
/**
 * Checks if the given value is a Signal.
 *
 * @template T - The value type of the signal.
 * @param value - The value to check.
 * @returns A boolean indicating whether the value is a Signal.
 */
function isSignal(value) {
    return typeof value === 'function' && signalSymbol in value;
}

const arraySignalSymbol = Symbol('ArraySignal');
/**
 * Creates an `ArraySignal` which is a reactive signal for an array of values.
 *
 * @template T - The type of elements in the array.
 * @param {readonly T[]} [value=[]] - The initial value of the array.
 * @returns {ArraySignal<T>} A reactive signal for the array.
 *
 * @example
 * ```ts
 * const myArraySignal = arraySignal([1, 2, 3]);
 *
 * // Getter
 * const currentArray = myArraySignal();
 *
 * // Setter
 * myArraySignal([4, 5, 6]);
 *
 * // Push new values
 * myArraySignal.push(7, 8);
 *
 * // Insert value at specific index
 * myArraySignal.insertAt(1, 9);
 *
 * // Remove specific value
 * myArraySignal.remove(2);
 *
 * // Remove value at specific index
 * myArraySignal.removeAt(0);
 *
 * // Swap values at two indices
 * myArraySignal.swap(0, 1);
 *
 * // Clear the array
 * myArraySignal.clear();
 *
 * // Peek the current value without taking a dependency
 * const peekedArray = myArraySignal.peek();
 * ```
 */
function arraySignal(value = []) {
    const innerSignal = signal([...value]);
    function fn(newValue) {
        if (arguments.length === 1) {
            innerSignal([...newValue]);
            return;
        }
        return innerSignal();
    }
    fn[arraySignalSymbol] = true;
    fn.push = (...values) => {
        innerSignal([...innerSignal.peek(), ...values]);
    };
    fn.insertAt = (index, value) => {
        const values = [...innerSignal.peek()];
        insertAt(values, index, value);
        innerSignal(values);
    };
    fn.remove = (value) => {
        const values = [...innerSignal.peek()];
        remove(values, value);
        innerSignal(values);
    };
    fn.removeAt = (index) => {
        const values = [...innerSignal.peek()];
        removeAt(values, index);
        innerSignal(values);
    };
    fn.swap = (i, j) => {
        const values = [...innerSignal.peek()];
        swap(values, i, j);
        innerSignal(values);
    };
    fn.clear = () => {
        innerSignal([]);
    };
    fn.peek = () => innerSignal.peek();
    fn.subscribe = (fn) => innerSignal.subscribe(fn);
    return fn;
}
/**
 * Checks if the given value is an ArraySignal.
 *
 * @template T - The type of elements in the array signal.
 * @param value - The value to check.
 * @returns A boolean indicating whether the value is an ArraySignal.
 */
function isArraySignal(value) {
    return typeof value === 'function' && arraySignalSymbol in value;
}

/**
 * Executes a function within a batch, ensuring that signal updates are batched together (atomic operation).
 *
 * @param fn - The function to be executed within the batch.
 *
 * @example
 * ```ts
 * const givenName = signal('Jane');
 * const familyName = signal('Doe');
 * const fullName = computed(() => givenName() + ' ' + familyName());
 *
 * effect(() => console.log(fullName()));
 * // "Jane Doe" logged
 *
 * // Combines both signal writes into one atomic update.
 * batch(() => {
 *   givenName('Foo');
 *   familyName('Bar');
 * });
 * // "Foo Bar" logged
 * ```
 */
function batch(fn) {
    o(fn);
}

/**
 * Creates a computed signal that derives its value from the provided function.
 *
 * @template T - The type of the value returned by the computed function.
 * @param {() => T} fn - A function that returns the value for the computed signal.
 * @returns {ReadonlySignal<T>} A readonly signal that provides the computed value.
 *
 * @example
 * ```ts
 * const myNumber = signal(42);
 * const double = computed(() => myNumber() * 2);
 * double() // 84
 *
 * myNumber(43);
 * double() // 86
 * ```
 */
function computed(fn) {
    const innerComputed = w(fn);
    function comp() {
        return innerComputed.value;
    }
    comp.peek = () => innerComputed.peek();
    comp.subscribe = (fn) => innerComputed.subscribe(fn);
    return comp;
}

/**
 * Calls the provided function, first initially, and when a signal dependency changes.
 *
 * The provided function can optionally return a cleanup function that will run only once.
 * It will run when the effect is disposed or right before the next invocation of provided function.
 *
 * @param fn
 * @returns A method to dispose the effect.
 *
 * @example
 * ```ts
 * const mySignal = signal(42);
 * effect(() => {
 *  console.log(mySignal());
 * });
 * // 42 is logged
 *
 * mySignal(43);
 * // 43 is logged
 * ```
 *
 * @example
 * ```ts
 * // Cleanup
 * effect(() => {
 *   addEventListener('click', handler);
 *   return () => { removeEventListener('click', handler); };
 * });
 * ```
 */
function effect(fn) {
    return E(fn);
}

// https://stackoverflow.com/questions/72205837/safe-type-debounce-function-in-typescript
/**
 * Wraps a function in a debounce function that will only execute
 * the provided function at a maximum frequency of once every `delayInMs` milliseconds.
 *
 * @param callback The function to debounce.
 * @param delayInMs The minimum amount of time that must pass between calls to the function.
 * @param immediate If true, the function will be called at the start of the wait period, rather than the end.
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function debounce(callback, delayInMs = 250, immediate = false) {
    let timeout = null;
    return function (...args) {
        const later = () => {
            timeout = null;
            if (!immediate) {
                callback.apply(this, args);
            }
        };
        const callNow = immediate && timeout === null;
        if (timeout !== null) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(later, delayInMs);
        if (callNow) {
            callback.apply(this, args);
        }
    };
}

/**
 * Creates a debounced computed value based on the provided function.
 * The value will be set immediately, and debounce thereafter. This means the computed value will be updated at a maximum
 * frequency of once every `delayInMs` milliseconds.
 *
 * @template T - The type of the computed value.
 * @param {() => T} func - The function that returns the computed value.
 * @param {number} [delayInMs] - The minimum amount of time that must pass between between each value update. If not provided, a default delay will be used.
 * @param {boolean} [immediate=false] - If true, the function will be called at the start of the wait period, rather than the end.
 * @returns {DebouncedComputed<T>} An object containing the debounced computed value and a dispose function.
 */
function debouncedComputed(func, delayInMs, immediate = false) {
    let isInitialized = false;
    let innerValue = signal(undefined); // We set the initial value in the effect
    const updateInnerValue = debounce(innerValue, delayInMs, immediate);
    const inputComputed = computed(func);
    const dispose = effect(() => {
        const newValue = inputComputed();
        if (!isInitialized) {
            // We want to set the value immediately on the first run.
            // No debounce is applied here.
            innerValue(newValue);
            isInitialized = true;
        }
        else {
            updateInnerValue(newValue);
        }
    });
    const value = computed(() => innerValue());
    return { value, dispose };
}

/**
 * Calls the provided function, without taking dependency on any signals called within it.
 * @param fn
 * @returns The value returned from `fn`.
 *
 * @example
 * ```ts
 * const signalA = signal('A');
 * const signalB = signal('B');
 *
 * function someFunction() {
 *   console.log(signalB());
 * }
 *
 * effect(() => {
 *   console.log(signalA());
 *   untracked(someFunction);
 * })
 * // A & B is logged
 *
 * signalA('A2');
 * // A2 & B is logged
 *
 * signalB('B2');
 * // Nothing is logged as we didn't take a dependency on signalB
 * ```
 */
function untracked(fn) {
    return h(fn);
}

export { arraySignal, batch, computed, debouncedComputed, effect, isArraySignal, isSignal, signal, untracked };
